import { Component, Input } from '@angular/core';

@Component({
    selector: 'curation-rank',
    styles: [`
         .rank-div {
            width:45px;
            padding-left: 1rem;
            line-height:30px;
        }
        
        .rank {
            display: inline-block;
            height: 19px;
            position: relative;
            vertical-align: middle;
            width: 19px;
        }
        .rank:before, .rank:after {
            background-repeat: no-repeat;
            bottom: 0;
            content: "";
            display: block;
            position: absolute;
            top: 0;
        }
        .rank:before {
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAsCAYAAAGLX3HuAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAK6ADAAQAAAABAAAALAAAAAD/NLnSAAABL0lEQVRYCe1WURKEIAjdmg7T/U/TbXbXD5wXYUjB7DrRj4jwgCea04t927a9i2pm+jqdSCJLmrc9uKXqQQZ1LAgiflVijKqs/l9hRgtaEC1rhWTFR0QSEbgDzRcSaESkdV13kW3IZ0gUjcZdGFLiiGCmNOKM46gLzBl55NuLfBc5Lg11u3kqfI5l4JopZXTU5PGAD+3JS2xx6NoWPOjZPIzj5WqpZ9mWtbCMxwMOOdIhNCSo1tb29XE4vXQt/uRKHIfTh2cq/l60ltHO2MM5fXj5t/+mWntp660Xk+QXsldSIA9dJuvBooSRzEqseOiSWQ8WJQz1NSg5oc5yT/7lkwCL8ZSzZz3ZRKxkFtnwlMWHfCvA3dPcwu3VZxv0MmW1S2atjPXaJ7O9TFnthmL2A2z4T34X5bVsAAAAAElFTkSuQmCC");
            background-position: left center;
            left: 0;
        }
        .rank:after {
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAsCAYAAAGLX3HuAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAK6ADAAQAAAABAAAALAAAAAD/NLnSAAABNUlEQVRYCe1WQRLCMAi0Tmf8hy/0Kb7Qf3hScyCzRVJCC6OZ0ksIgQU2JM10Yt/zfn0V1Znp63QiiSxp3vbglqoHGdSxIIj4VYkxqrL6f4QzWtCCaFkrJCs+IpKIwB1oPpNAIyJdbo9FZBvyGhJFo3ERhpQ4IpgpjTjjOOoCc0Ye+fYi30WOS0Pdbp4Kn2MZuGZKGR01eTzgr/bkJbY4dG0LHnRtHsbxvLXUtWzLWljG4wGHHOkQGhJUa2v7+jicbroWf3IljsPpwTMVfy9ay2hn7OCcHrz83X9Trb209daLSfIL2SspkIcuk/VgUcJIZiVWPHTJrAeLEob6GpScUGe5J//ySYDFeMrZs55sIlYyi2x4yuJDvhVg72lu4fbqsw16mbLaJbNWxnrtk9lepqx2QzH7BjWYRf8lViVVAAAAAElFTkSuQmCC");
            background-position: right center;
            right: 0;
            width: 100%;
        }
        .rank-1:before {
            width: 0%;
        }
        .rank-1:after {
            width: 100%;
        }
        .rank-2:before {
            width: 30%;
        }
        .rank-2:after {
            width: 70%;
        }
        .rank-3:before {
            width: 70%;
        }
        .rank-3:after {
            width: 30%;
        }
        .rank-4:before {
            width: 100%;
        }
        .rank-4:after {
            width: 0;
        }

        .rank-small {
            height: 22px;
            width: 22px;
        }

        .rank-large {
            height: 44px;
            width: 44px;
        }
        
        .rank-large:before {
            background-size: 44px 44px;
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAsCAYAAAGLX3HuAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAK6ADAAQAAAABAAAALAAAAAD/NLnSAAABNUlEQVRYCe1WQRLCMAi0Tmf8hy/0Kb7Qf3hScyCzRVJCC6OZ0ksIgQU2JM10Yt/zfn0V1Znp63QiiSxp3vbglqoHGdSxIIj4VYkxqrL6f4QzWtCCaFkrJCs+IpKIwB1oPpNAIyJdbo9FZBvyGhJFo3ERhpQ4IpgpjTjjOOoCc0Ye+fYi30WOS0Pdbp4Kn2MZuGZKGR01eTzgr/bkJbY4dG0LHnRtHsbxvLXUtWzLWljG4wGHHOkQGhJUa2v7+jicbroWf3IljsPpwTMVfy9ay2hn7OCcHrz83X9Trb209daLSfIL2SspkIcuk/VgUcJIZiVWPHTJrAeLEob6GpScUGe5J//ySYDFeMrZs55sIlYyi2x4yuJDvhVg72lu4fbqsw16mbLaJbNWxnrtk9lepqx2QzH7BjWYRf8lViVVAAAAAElFTkSuQmCC");
        }

        .rank-large:after {
            background-size: 44px 44px;
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAsCAYAAAGLX3HuAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAK6ADAAQAAAABAAAALAAAAAD/NLnSAAABL0lEQVRYCe1WURKEIAjdmg7T/U/TbXbXD5wXYUjB7DrRj4jwgCea04t927a9i2pm+jqdSCJLmrc9uKXqQQZ1LAgiflVijKqs/l9hRgtaEC1rhWTFR0QSEbgDzRcSaESkdV13kW3IZ0gUjcZdGFLiiGCmNOKM46gLzBl55NuLfBc5Lg11u3kqfI5l4JopZXTU5PGAD+3JS2xx6NoWPOjZPIzj5WqpZ9mWtbCMxwMOOdIhNCSo1tb29XE4vXQt/uRKHIfTh2cq/l60ltHO2MM5fXj5t/+mWntp660Xk+QXsldSIA9dJuvBooSRzEqseOiSWQ8WJQz1NSg5oc5yT/7lkwCL8ZSzZz3ZRKxkFtnwlMWHfCvA3dPcwu3VZxv0MmW1S2atjPXaJ7O9TFnthmL2A2z4T34X5bVsAAAAAElFTkSuQmCC");
        }

        .rank-small:before {
            background-size: 22px 22px;
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAsCAYAAAGLX3HuAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAK6ADAAQAAAABAAAALAAAAAD/NLnSAAABNUlEQVRYCe1WQRLCMAi0Tmf8hy/0Kb7Qf3hScyCzRVJCC6OZ0ksIgQU2JM10Yt/zfn0V1Znp63QiiSxp3vbglqoHGdSxIIj4VYkxqrL6f4QzWtCCaFkrJCs+IpKIwB1oPpNAIyJdbo9FZBvyGhJFo3ERhpQ4IpgpjTjjOOoCc0Ye+fYi30WOS0Pdbp4Kn2MZuGZKGR01eTzgr/bkJbY4dG0LHnRtHsbxvLXUtWzLWljG4wGHHOkQGhJUa2v7+jicbroWf3IljsPpwTMVfy9ay2hn7OCcHrz83X9Trb209daLSfIL2SspkIcuk/VgUcJIZiVWPHTJrAeLEob6GpScUGe5J//ySYDFeMrZs55sIlYyi2x4yuJDvhVg72lu4fbqsw16mbLaJbNWxnrtk9lepqx2QzH7BjWYRf8lViVVAAAAAElFTkSuQmCC");
        }

        .rank-small:after {
            background-size: 22px 22px;
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAsCAYAAAGLX3HuAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAK6ADAAQAAAABAAAALAAAAAD/NLnSAAABL0lEQVRYCe1WURKEIAjdmg7T/U/TbXbXD5wXYUjB7DrRj4jwgCea04t927a9i2pm+jqdSCJLmrc9uKXqQQZ1LAgiflVijKqs/l9hRgtaEC1rhWTFR0QSEbgDzRcSaESkdV13kW3IZ0gUjcZdGFLiiGCmNOKM46gLzBl55NuLfBc5Lg11u3kqfI5l4JopZXTU5PGAD+3JS2xx6NoWPOjZPIzj5WqpZ9mWtbCMxwMOOdIhNCSo1tb29XE4vXQt/uRKHIfTh2cq/l60ltHO2MM5fXj5t/+mWntp660Xk+QXsldSIA9dJuvBooSRzEqseOiSWQ8WJQz1NSg5oc5yT/7lkwCL8ZSzZz3ZRKxkFtnwlMWHfCvA3dPcwu3VZxv0MmW1S2atjPXaJ7O9TFnthmL2A2z4T34X5bVsAAAAAElFTkSuQmCC");
        }
    `],
    template: `
        <div [ngSwitch]="score">
            <div *ngSwitchCase="1" class="rank rank-large rank-2" [ngClass]="{ 'rank-large': size === 'large', 'rank-small': size === 'small' }"></div>
            <div *ngSwitchCase="2" class="rank rank-large rank-3" [ngClass]="{ 'rank-large': size === 'large', 'rank-small': size === 'small' }"></div>
            <div *ngSwitchCase="3" class="rank rank-large rank-4" [ngClass]="{ 'rank-large': size === 'large', 'rank-small': size === 'small' }"></div>
            <div *ngSwitchDefault  class="rank rank-large rank-1" [ngClass]="{ 'rank-large': size === 'large', 'rank-small': size === 'small' }"></div>
        </div>
    `
})
export class CurationRankComponent {
    @Input() score: number = 0;
    @Input() size = 'large';
}
